import { ReactElement, useRef } from 'react';
import { useHistory } from 'react-router-dom';

// Components
import DocumentComplete from '../DocumentComplete';
import SegmentView from '../../../components/SegmentView';

// Hooks
import useUserAttributes from '../../../hooks/useUserAttributes';

// Models
import Document from '../../../core-data-service/models/Document';

// Redux
import { useDispatch } from '../../../store';
import { setUserAttributes } from '../../../store/reducers/userReducer';

// Routes
import {
  poa as poaRoute,
} from '../../../../core/routes';

export default function PoaReview(): ReactElement{
  const dispatch = useDispatch();
  const { push } =  useHistory();
  const { documents: { poa: { poaDocumentViewed: isPoaDocumentViewed } } } = useUserAttributes();
  const documentType = Document.TYPE_POWER_OF_ATTORNEY;

  const hasCurrentPoaBeenViewed = useRef( isPoaDocumentViewed );

  const setPoaReviewedAttribute = ( poaPreviewViewed: boolean, onSuccess?: ()=> void ) =>{
    dispatch( setUserAttributes({ 'app.poaDocumentViewed': poaPreviewViewed, onSuccess }));
  };

  const handleMakeChangesAction = () => {
    setPoaReviewedAttribute( false, () => push( poaRoute.get()));
  };

  return(
    <SegmentView
      contentClassName="absolute inset-0 z-10"
      full
      onRetreat={ () => push( poaRoute.get()) }
      hidePrimaryAction={ true }
      hideSecondaryAction={ true }
      shouldHideBackButton={ true }
      hideLogo={ true }
    >
      <DocumentComplete
        documentType={ documentType }
        hasSeenView={ !!hasCurrentPoaBeenViewed.current }
        onClickEdit={ handleMakeChangesAction }
        onRender={ ()=> setPoaReviewedAttribute( true ) }
      />
    </SegmentView>
  );
}
